import i18n from '@/utils/i18n';

const filters =
  [
    {
      name: "events.title",
      placeholder: i18n.t('form.event_title_placeholder'),
      type: "text",
      label: i18n.t('form.event_title'),
    },
    {
      name: "type",
      searchable: false,
      placeholder: i18n.t('form.any'),
      value: "",
      type: "select",
      preselectFirst: true,
      multiple: false,
      options: [
        { label: 'Admin Mail', value: 'admin_mail' },
        // {label: 'Campaignmonitor', value: 'campaignmonitor'},
        { label: 'Hubspot', value: 'hubspot' },
        { label: 'Mail', value: 'mail' },
        { label: 'Mailchimp', value: 'mailchimp' },
        { label: 'Klaviyo', value: 'klaviyo' },
        { label: 'ActiveCampaign', value: 'activecampaign' },
        { label: 'Moderator Mail', value: 'moderator_mail' },
        { label: 'Segment', value: 'segment' },
        { label: 'Slack', value: 'slack' },
        { label: 'Streak', value: 'streak' },
        { label: 'Subscription', value: 'subscription' },
        { label: 'Webhook', value: 'webhook' },
      ],
      label: i18n.t('form.type'),
      main: false
    },
    {
      name: "active",
      searchable: false,
      placeholder: i18n.t('form.any'),
      value: "",
      type: "select",
      preselectFirst: true,
      multiple: false,
      options: [
        { label: 'Active', value: true },
        { label: 'Not Active', value: false },
      ],
      label: i18n.t('form.active'),
      main: false
    }
  ];

export default filters